import { isPositiveNumber, reduce } from "et3-type-guards";
import React from "react";
import { useLocation } from "react-router-dom";

import UserSearchForm from "../../../components/user-pages/UserSearchForm";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserStore from "../../../stores/user-store";
import getUserEventsStore from "../../../stores/user-store/events-store";
import UserEventsData from "./user-events-data";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const UserEvents = withLiteObserverAndTheme(() => {
  const location = useLocation();

  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_EVENTS", "USER_EVENTS");
    getUserEventsStore().checkURLSearch(search);
  }, []);

  const userID = getUserStore().userIdInput.get();
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("MONITOR_USER_EVENTS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserSearchForm
        withPlatform={false}
        withLimit={true}
        disabled={!isPositiveNumber(userID)}
        onClickAction={async () => getUserEventsStore().getUserEvents()}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserEventsData />
    </ET3PageDiv>
  );
});
export default UserEvents;
